
class Inform_i18n {
    private static _i18n_translation = {

        es: {
            title: "Informe de eco-eficiencia",
            lengthbtwPerpendicular: "Eslora entre perpendiculares",
            height: "Altura",
            grossTonnage: "Arqueo Bruto",
            capacityDeadWeight: "Peso muerto del buque",
            displacementVolume: "Volumen de desplazamiento",
            lengthOverall: "Longitud total",
            summerLoad: "Calado en la línea de carga de verano",
            breadth: "Manga",
            baseConfiguration: "Configuración base",
            micellaneousCosts: "Costes diversos",
            configuration: "Configuración ",
            technicalStopDuration: "Duración de la parada técnica",
            dailyCosts: "Gastos diarios",
            initialInvestment: "Inversión inicial",
            financing: "Financiación",
            amountToFinance: "Importe de la financiación",
            interestRate: "Tipo de interés",
            amortizationPeriod: "Período de amortización",
            discountRate: "Tasa de descuento",
            timeDays: "Días",
            capacity: "Capacidad",
            attainedEEXI: "EEXI calculado alcanzado",
            indiceHeader: "Índice de eco-efficiencia",
            titleBase: "Datos del barco",
            ciiHeader: "Índice operativo de la intensidad de carbono (CII)",

            
            

            shipSpeed: "Velocidad de referencia",
            vTanks: "Capacidad cúbica total de los tanques de carga",
            powerLimitElement: "Curvas de velocidad-potencia obtenidas a partir de las pruebas del modelo en la fase final o del informe de las pruebas en el mar",
            vsService: "Velocidad de servicio en las pruebas",
            dwtsService: "Peso muerto al calado de diseño",
            psService: "Potencia del motor principal",
            structuralEnhancement: "Mejoras estructurales voluntarias específicas",
            lwtReferenceDesign: "Desplazamiento en rosca del proyecto de referencia",
            lwtEnhancedDesign: "Desplazamiento en rosca del proyecto mejorado",
            has_csr: "Buques sujetos a las reglas estructurales comunes (CSR)",
            deadweightCSR: "Peso muerto CSR",
            lightweightCSR: "Desplazamiento en rosca CSR",
            has_sideLoaders: "¿Dispone de cargadores laterales?",
            capacityNoSideloaders: "Capacidad sin cargadores laterales",
            capacitySideloaders: "Capacidad con cargadores laterales",
            highSpeedCruise: "Crucero de alta velocidad",
            has_roro_ramps: "¿Dispone de rampas de transbordo?",
            capacityNoRORORamp: "Capacidad sin rampas de transbordo",
            capacityRORORamp: "Capacidad con rampas de transbordo",
            isChemicalTanker: "¿El buque es quimiquero?",
            capacityCorrection: "Corrección de la capacidad para buques con clasificación para navegación en hielo?",
            cb: "Coeficiente de bloque",
            addCrane: "Añadir grúa",
            removeCrane: "Eliminar grúa",
            requiredFields: "Campos Obligatorios",
            save: "Guardar",
            cancel: "Cancelar",
            showInfo: "Mostrar Informe",
            calcRequiredEEXI: "Calculo EEXI requerido",
            


        },

        en: {
            title: "Eco-efficiency report",
            lengthbtwPerpendicular: "Length between perpendiculars",
            height: "Height",
            configuration: "Configuration",
            baseConfiguration: "Base Configuration",
            micellaneousCosts: "Miscellaneous costs",
            technicalStopDuration: "Technical stop duration",
            dailyCosts: "Daily costs",
            initialInvestment: "Initial investment",
            financing: "Financing",
            amountToFinance: "Amount to finance",
            interestRate: "Interest rate",
            amortizationPeriod: "Amortization period",
            discountRate: "Discount rate",
            timeDays: "Days",
            capacity: "Capacity",
            attainedEEXI: "Calculated attained EEXI",
            indiceHeader: "Eco-efficiency index",
            capacityCorrection: "Capacity correction",
            titleBase: "Ship Data",
            ciiHeader:"Operational Carbon Intensity Index (CII)",
            
            
            grossTonnage: "Gross Tonnage",
            capacityDeadWeight: "Capacity DeadWeight",
            

            displacementVolume: "Displacement Volume",
            lengthOverall: "Length Overall",
            summerLoad: "Summer load line draught",
            breadth: "Breadth",
            shipSpeed: "Ship speed",
            vTanks: "Total cubic capacity of the cargo tanks",
            powerLimitElement: "Speed-power curves obtained from model testing at final stage or sea trial report",
            vsService: "Testing service speed",
            dwtsService: "Testing deadweight",
            psService: "Testing main engine power",
            structuralEnhancement: "Ship specific voluntary structural enhancement",
            lwtReferenceDesign: "Reference design lightweight",
            lwtEnhancedDesign: "Enhanced design lightweight",
            has_csr: "Ships under the Common Structural Rules (CSR)",
            deadweightCSR: "Deadweight CSR",
            lightweightCSR: "Light weight CSR",
            has_sideLoaders: "Side loaders are present?",
            capacityNoSideloaders: "Capacity without sideloaders",
            capacitySideloaders: "Capacity with sideloaders",
            highSpeedCruise: "High Speed Cruise?",
            has_roro_ramps: "RO-RO ramp is present?",
            capacityNoRORORamp: "Capacity without RO-RO ramp",
            capacityRORORamp: "Capacity with RO-RO ramp",
            isChemicalTanker: "Chemical Tanker?",
            cb: "Block coefficient",
            addCrane: "Add Crane",
            removeCrane: "Remove Crane",
            requiredFields: "Required fields",
            save: "Save",
            cancel: "Cancel",
            showInfo: "Show Info",
            calcRequiredEEXI: "Calc Required EEXI",
        }

    }

    public static getTranslationText(state: string ) {
        if (state == 'es'){
            return this._i18n_translation.es
            
        }else{
            return this._i18n_translation.en
        }
    }
   
}

export default Inform_i18n;